(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sidenav", [], factory);
	else if(typeof exports === 'object')
		exports["sidenav"] = factory();
	else
		root["sidenav"] = factory();
})(this, function() {
return 